import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tag,
  Typography,
} from "antd";
import { useState, useCallback, useMemo, useEffect } from "react";
import {
  ReloadOutlined,
  FileAddOutlined,
  SearchOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import {
  HEADERS_EXPORT_BEN,
  POST_ACCEPT_CEO_RECHECK_JUDGE_DOC,
  POST_MAIN_RECHECK_JUDGE_DOC,
} from "../../API/apiUrls";
import axios from "axios";
import dayjs from "dayjs";
import MotionHoc from "../../../utils/MotionHoc";

import CurrencyFormat from "../../../hook/CurrencyFormat";
import CheckingDocumentsEnforce from "./modal/CheckingDocumentsEnforce";

const { Option } = Select;

const Main = () => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  // States
  const [dataArr, setDataArr] = useState([]);
  const [dataRaw, setDataRaw] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [processStatus, setProcessStatus] = useState(1);
  const [dataRecord, setDataRecord] = useState(null);
  const [isModal, setIsModal] = useState(false);

  // Selection states
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // const loadMain = useCallback(
  //   async (status) => {
  //     setLoading(true);
  //     setSearchInputTable("");
  //     try {
  //       const res = await axios.post(
  //         POST_MAIN_RECHECK_JUDGE_DOC,
  //         { userId, currentStatus: status },
  //         { headers: HEADERS_EXPORT_BEN },
  //       );

  //       if (res.data?.length > 0) {
  //         const sortedData = [...res.data].sort((a, b) => {
  //           const dateA_Ceo = a.dtCompleteCheckJudgeCeo
  //             ? new Date(a.dtCompleteCheckJudgeCeo)
  //             : 0;
  //           const dateB_Ceo = b.dtCompleteCheckJudgeCeo
  //             ? new Date(b.dtCompleteCheckJudgeCeo)
  //             : 0;

  //           if (dateA_Ceo !== dateB_Ceo) {
  //             return dateB_Ceo - dateA_Ceo; // เรียงจากใหม่ไปเก่า
  //           }

  //           const dateA_Acc = a.dtCompleteAcc ? new Date(a.dtCompleteAcc) : 0;
  //           const dateB_Acc = b.dtCompleteAcc ? new Date(b.dtCompleteAcc) : 0;

  //           return dateB_Acc - dateA_Acc;
  //         });

  //         console.log("sortedData", sortedData);
  //         setDataArr(sortedData);
  //       } else {
  //         setDataArr([]);
  //         message.info("ไม่มีข้อมูล");
  //       }
  //     } catch (error) {
  //       if (error.name !== "CanceledError") {
  //         message.error(
  //           error.response?.data?.message ||
  //             error.message ||
  //             "ไม่สามารถโหลดข้อมูลได้",
  //         );
  //         setDataArr([]);
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [userId, processStatus],
  // );

  useEffect(() => {
    // if ((ROLE_ID === "5" || ROLE_ID === "1") && processStatus === 20) {
    //   loadMain(processStatus);
    // }
    setDataRaw(mockDataSource);
    setDataArr(mockDataSource);
  }, []);

  const mockDataSource = [
    {
      key: "1", // Ant Design table แนะนำให้มี key
      newContno: "L-660001",
      SNAM: "นาย",
      NAME1: "สมชาย",
      NAME2: "ใจดี",
      investigateStatus: 1, // 🎯 เจอทรัพย์สืบออนไลน์
      actionDate: "2026-06-15T10:30:00", // วันที่ดำเนินการ
      currentStatus: 17, // ปุ่มจะแสดงเป็นสีฟ้า (blue)
    },
    {
      key: "2",
      newContno: "L-660002",
      SNAM: "นาง",
      NAME1: "สมหญิง",
      NAME2: "มั่งคั่ง",
      investigateStatus: 2, // ❌ ไม่เจอทรัพย์สืบออนไลน์
      actionDate: "2026-06-16T09:15:00",
      currentStatus: 10, // ปุ่มจะแสดงเป็นสีเขียว (green) เพราะไม่ใช่ 17
    },
    {
      key: "3",
      newContno: "L-660003",
      SNAM: "นางสาว",
      NAME1: "เรียนดี",
      NAME2: "รักสงบ",
      investigateStatus: 4, // 🕒 ดำเนินการส่งสืบออนไลน์
      actionDate: "2026-06-17T11:00:00",
      currentStatus: 2, // ปุ่มจะแสดงเป็นสีฟ้า (blue)
    },
    {
      key: "4",
      newContno: "L-660004",
      SNAM: "นาย",
      NAME1: "สายฟ้า",
      NAME2: "พาเพลิน",
      investigateStatus: 2, // 📤 ยังไม่ได้สืบทรัพย์ออนไลน์
      actionDate: "2026-06-17T14:20:00",
      currentStatus: 5, // ปุ่มจะแสดงเป็นสีเขียว (green)
    },
  ];

  const statusOptions = useMemo(
    () => [
      { value: 1, icon: "🎯 ", label: " เจอทรัพย์สืบออนไลน์" },
      { value: 2, icon: "❌ ", label: " ไม่เจอทรัพย์สืบออนไลน์" },
      { value: 4, icon: "🕒 ", label: " ดำเนินการส่งสืบออนไลน์" },
      { value: 3, icon: "📤 ", label: " ยังไม่ได้สืบทรัพย์ออนไลน์" },
    ],
    [],
  );

  const handleChangeStatus = useCallback(
    (value) => {
      const data = dataRaw;
      clearSelectedRows();
      // setDataArr([]);
      clearSelectedRows();
      setProcessStatus(value);
      // loadMain(value);

      const filterData = data.filter(
        (item) => item.investigateStatus === value,
      );
      setDataArr(filterData);
    },
    [dataRaw],
  );

  // ✅ กรองข้อมูลอัตโนมัติด้วย useMemo
  const arrayTable = useMemo(() => {
    if (!dataArr || dataArr.length === 0) return [];

    const normalize = (value) =>
      String(value ?? "")
        .trim()
        .toLowerCase();

    const searchQuery = normalize(searchInputTable);

    return dataArr.filter((item) => {
      const passQuery =
        !searchQuery ||
        [
          item.newContno,
          item.CUSCOD,
          item.CONTNO,
          item.NAME1,
          item.NAME2,
          `${item.SNAM || ""}${item.NAME1 || ""} ${item.NAME2 || ""}`,
        ]
          .map(normalize)
          .some((val) => val.includes(searchQuery));

      return passQuery;
    });
  }, [dataArr, searchInputTable]);

  // ✅ ฟังก์ชันล้างฟิลเตอร์
  const handleResetFilter = useCallback(() => {
    setSearchInputTable("");
    message.info("ล้างตัวกรองสำเร็จ");
  }, []);

  // const handleReloadJudgment = useCallback(
  //   (payload) => {
  //     clearSelectedRows();
  //     setDataRecord(null);
  //     const status = payload?.process ?? processStatus;
  //     loadMain(status);
  //   },
  //   [loadMain, processStatus],
  // );

  const postDocStatus = async (payload, apiUse) => {
    console.log("📤 POST_DOC_STATUS with data:", payload);

    try {
      const res = await axios.post(apiUse, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const { status, data } = res;

      if (status === 200) {
        console.log("✅ API Response:", data);
        return data;
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }

      console.error("❌ postDocStatus error:", error);
      throw error;
    }
  };

  const handleBulkSave = async () => {
    if (selectedRowKeys.length === 0) {
      message.warning("กรุณาเลือกรายการที่ต้องการดำเนินการ");
      return;
    }

    setLoading(true);
    let successCount = 0;
    let failCount = 0;

    try {
      const selectedRecords = arrayTable.filter((item) =>
        selectedRowKeys.includes(item.CONTNO),
      );
      console.log(`📤 กำลังส่งข้อมูล ${selectedRecords.length} รายการ...`);

      for (const record of selectedRecords) {
        try {
          await postDocStatus(
            {
              loanId: record.loanId,
              lawsuitId: record.lawsuitId,
              userId: userId,
            },
            POST_ACCEPT_CEO_RECHECK_JUDGE_DOC,
          );

          successCount++;
          console.log(`✅ สำเร็จ: ${record.CONTNO}`);
        } catch (err) {
          failCount++;
          console.error(`❌ ล้มเหลว: ${record.CONTNO}`, err);
        }
      }

      if (successCount > 0) {
        message.success(
          `รับงานสำเร็จ ${successCount} รายการ${
            failCount > 0 ? `, ล้มเหลว ${failCount} รายการ` : ""
          }`,
        );
        // handleReloadJudgment();
      } else {
        message.error("ไม่สามารถดำเนินการได้");
      }
    } catch (err) {
      console.error("❌ Error in bulk save:", err);
      message.error("เกิดข้อผิดพลาดในการดำเนินการ");
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
      console.log("Selected Keys:", selectedKeys);
    },
    getCheckboxProps: (record) => ({}),
  };

  const clearSelectedRows = () => {
    setSelectedRowKeys([]);
  };

  const renderStatus = (record) => {
    const matchedStatus = statusOptions.find(
      (opt) => opt.value === record.investigateStatus,
    );
    const icon = matchedStatus?.icon || "❓ ";
    const label = matchedStatus?.label || " ไม่ทราบสถานะ";

    // 3. กำหนดสีของ Tag ให้สอดคล้องกับสถานะ
    let tagColor = "default";
    if (record.investigateStatus === 1)
      tagColor = "success"; // 1: เจอทรัพย์ -> สีเขียว
    else if (record.investigateStatus === 2)
      tagColor = "error"; // 2: ไม่เจอทรัพย์ -> สีแดง
    else if (record.investigateStatus === 4)
      tagColor = "processing"; // 4: ดำเนินการ -> สีฟ้า
    else if (record.investigateStatus === 3) tagColor = "warning"; // 3: ยังไม่ได้สืบ -> สีเหลือง/ส้ม

    return (
      <Space direction="vertical" size={2}>
        <Tag color={tagColor}>
          {icon} {label}
        </Tag>
      </Space>
    );
  };

  // ✅ Columns สำหรับตาราง
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "newContno",
      key: "newContno",
      align: "center",
      width: 150,
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "fullName",
      align: "center",
      render: (_, record) => (
        <span>
          {`${record.SNAM || ""}${record.NAME1 || ""} ${
            record.NAME2 || ""
          }`.trim()}
        </span>
      ),
    },
    {
      title: "สถานะ/ทรัพย์",
      dataIndex: "",
      key: "",
      align: "center",
      render: (_, record) => renderStatus(record),
    },
    {
      title: "วันที่ดำเนินการ",
      align: "center",
      render: (text, record) => {
        return (
          <div>
            <Tag color="blue" style={{ textAlign: "center" }}>
              {dayjs(record.actionDate).format("DD MMM YY")}
            </Tag>
          </div>
        );
      },
    },
    {
      title: "การจัดการ",
      key: "actions",
      align: "center",
      width: 180,
      render: (_, record) => {
        return (
          <Space>
            {record.investigateStatus !== 4 && (
              <Button
                color={record.currentStatus === 17 ? "blue" : "red"}
                variant="outlined"
                icon={<FileAddOutlined />}
                onClick={() => {
                  setDataRecord(record);
                  setIsModal(true);
                }}
              >
                มอบงาน
              </Button>
            )}
          </Space>
        );
      },
    },
  ].filter(Boolean);

  return (
    <>
      <Card
        style={{
          marginBottom: 8,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          {/* Label */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              borderRadius: 8,
              background: "#fff3cc",
              border: "1px solid #ffcb05",
            }}
          >
            <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
            <span style={{ fontSize: 13, fontWeight: 500, color: "#efa420" }}>
              เลือกสถานะ
            </span>
          </div>

          {/* Select */}
          <Select
            size="large"
            style={{ minWidth: 240 }}
            placeholder="เลือกสถานะ"
            value={processStatus}
            onChange={(val) => handleChangeStatus(val)}
            optionLabelProp="label"
          >
            {statusOptions.map(({ value, icon, label }) => (
              <Option key={value} value={value} label={`${icon} ${label}`}>
                <Space>
                  <span style={{ fontSize: 14 }}>{icon}</span>
                  <span>{label}</span>
                </Space>
              </Option>
            ))}
          </Select>

          {/* ✅ Tag ชิดขวา */}
          {processStatus &&
            (() => {
              const found = statusOptions.find(
                (o) => o.value === processStatus,
              );
              return found ? (
                <Tag
                  style={{
                    marginLeft: "auto", // ✅ ดันไปขวาสุด
                    fontSize: 13,
                    borderRadius: 20,
                    padding: "3px 12px",
                    background: "#fff3cc",
                    border: "1px solid #ffcb05",
                    color: "#efa420",
                    fontWeight: 500,
                  }}
                >
                  {found.icon} {found.label}
                </Tag>
              ) : null;
            })()}
        </div>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          <Row gutter={[0, 16]}>
            <Col span={12} style={{ textAlign: "start" }}>
              <Button
                type="primary"
                ghost
                danger
                icon={<InboxOutlined />}
                onClick={() => handleBulkSave()}
                disabled={selectedRowKeys.length === 0 && processStatus === 1}
              >
                📥 ส่งสืบออนไลน์ ({selectedRowKeys.length})
              </Button>
            </Col>
            <Col span={12} style={{ textAlign: "end" }}>
              <Space size={10} wrap>
                <Input
                  placeholder="ค้นหาเลขสัญญา, ชื่อ"
                  value={searchInputTable}
                  onChange={(e) => setSearchInputTable(e.target.value)}
                  style={{ width: 250, borderRadius: 8 }}
                  size="small"
                  allowClear
                  suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                />

                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleResetFilter}
                  size="large"
                  style={{
                    borderRadius: 8,
                    backgroundColor: "#fff1f0",
                    borderColor: "#ffa39e",
                    color: "#cf1322",
                  }}
                >
                  ล้างตัวกรอง
                </Button>
              </Space>
            </Col>

            {/* Table */}
            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                rowKey={(record) => record.CONTNO || record.id}
                scroll={{ x: 1000 }}
                rowSelection={processStatus !== 1 ? rowSelection : null}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total) => `ทั้งหมด ${total} รายการ`,
                  pageSizeOptions: ["10", "20", "50", "100"],
                }}
                footer={() => (
                  <div style={{ alignItems: "center" }}>
                    <p style={{ margin: 0 }}>
                      จำนวนสัญญาทั้งหมด {arrayTable?.length}{" "}
                      {` | เลือก ${selectedRowKeys.length} รายการ`}
                    </p>
                  </div>
                )}
              />
            </Col>
          </Row>
        </Spin>
        {isModal && (
          <CheckingDocumentsEnforce
            open={isModal}
            close={() => setIsModal(false)}
            dataDefault={dataRecord}
            // func={handleReloadJudgment}
            process={processStatus}
          />
        )}
      </Card>
    </>
  );
};

const AssignInvestigateOnsite = MotionHoc(Main);
export default AssignInvestigateOnsite;
